import axios from 'axios';


// Create an Axios instance with a base URL
const axiosInstance = axios.create({
  baseURL: '/api'
});

// Add a request interceptor to include the Language header
axiosInstance.interceptors.request.use(
  (config) => {
    const lang = localStorage.getItem('i18nextLng') || 'ar';
    config.headers['lang'] = lang.startsWith('en') ? 'en' : 'ar';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    if(response.status === 200 && response.data.status !== "Success") {
      return Promise.reject({response});
    }
    // Any status code within the range of 2xx causes this function to trigger
    return response.data.isList ? response.data.dataList : response.data.dataItem  ;
  },
  (error) => {
    console.log("error", error)
    // Any status codes outside the range of 2xx cause this function to trigger
    // Handle response errors
    if (error.response && error.response.status === 401) {
      // Skip redirect for the auth-check call — 401 there just means "not logged in".
      // The background unread-count poll also stays quiet; the notifications watcher stops on 401.
      const url = error.config?.url || '';
      const isAuthCheck = url.includes('/User/Info') || url.includes('/notifications/unread-count');
      // Prevent infinite redirect loop
      if (!window.location.pathname.includes('/login') && !isAuthCheck) {
        // Clear service worker cache on 401 to prevent corrupted cache issues
        if ('serviceWorker' in navigator && 'caches' in window) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        
        // Clear storage and redirect to login
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
      }
    }
    
    // Return a consistent error object
    if (error.response?.data) {
      return Promise.reject(error.response.data);
    }
    
    // For network errors or other errors without response
    return Promise.reject({
      message: error.message || 'حدث خطأ في الاتصال',
      error: error.code || 'NETWORK_ERROR',
      status: error.response?.status
    });
  }
);
export default axiosInstance;
